export const router = {
  // admin/mod
  Dashboard: {
    path: "/dashboard",
  },
  ForgetPassword: { path: "/forget-password" },
  ResetPassword: { path: "/reset-password" },
  //! master
  // user
  ListUser: { path: "/master/user/list" },
  GetUserId: { path: "/master/user/view/:id" },
  EditUser: { path: "/master/user/edit/:id" },
  AddUser: { path: "/master/user/add/" },
  // role
  ListRole: { path: "/master/role/list" },
  AddRole: { path: "/master/role/add" },
  EditRole: { path: "/master/role/edit/:id" },
  ViewRole: { path: "/master/role/view/:id" },
  // layanan
  ListLayanan: { path: "/master/layanan/list" },
  AddLayanan: { path: "/master/layanan/add" },
  EditLayanan: { path: "/master/layanan/edit/:id" },
  ViewLayanan: { path: "/master/layanan/view/:id" },
  // jenis pembiayaan
  ListJenisPembiayaan: { path: "/master/jenis-pembiayaan/list" },
  AddJenisPembiayaan: { path: "/master/jenis-pembiayaan/add" },
  EditJenisPembiayaan: { path: "/master/jenis-pembiayaan/edit/:id" },
  ViewJenisPembiayaan: { path: "/master/jenis-pembiayaan/view/:id" },
  // fakultas
  ListFakultas: { path: "/master/fakultas/list" },
  AddFakultas: { path: "/master/fakultas/add" },
  EditFakultas: { path: "/master/fakultas/edit/:id" },
  ViewFakultas: { path: "/master/fakultas/view/:id" },
  // prodi
  ListProdi: { path: "/master/prodi/list" },
  AddProdi: { path: "/master/prodi/add" },
  ViewProdi: { path: "/master/prodi/view/:id" },
  EditProdi: { path: "/master/prodi/edit/:id" },
  // dokumen
  ListDokumen: { path: "/master/dokumen/list" },
  AddDokumen: { path: "/master/dokumen/add" },
  ViewDokumen: { path: "/master/dokumen/view/:id" },
  EditDokumen: { path: "/master/dokumen/edit/:id" },
  // kode payment VA
  ListKodepayment: { path: "/master/kode-payment/list" },
  ListKodepaymentDetail: { path: "/master/kode-payment/list/:period" },
  AddKodepayment: { path: "/master/kode-payment/add" },
  ViewKodepayment: { path: "/master/kode-payment/view/:id" },
  EditKodepayment: { path: "/master/kode-payment/edit/:id" },
  // Profile
  Profile: { path: "/profile" },
  ProfilePassword: { path: "/profile-password" },
  // pembayaran VA
  ListPembayaranVA: {
    path: "/va/list",
  },
  DetailPembayaranVA: {
    path: "/va/detail/:id",
  },
  CreatePembayaranVA: {
    path: "/va/create",
  },
  EditPembayaranVA: {
    path: "/va/edit/:id",
  },
  ReportPembayaranVA: {
    path: "/va/report",
  },
  OverviewPembayaranVA: {
    path: "/va/overview",
  },
  // Permohonan
  ListPermohonan: {
    path: "/permohonan/list",
  },
  DetailPermohonan: {
    path: "/permohonan/detail/:id",
  },
  CreatePermohonan: {
    path: "/permohonan/create",
  },
  EditPermohonan: {
    path: "/permohonan/edit/:id",
  },
  ReportPermohonan: {
    path: "/permohonan/report",
  },
  OverviewPermohonan: {
    path: "/permohonan/overview",
  },
  // Praktikum
  ListPraktikum: {
    path: "/praktikum/list",
  },
  DetailPraktikum: {
    path: "/praktikum/detail/:id",
  },
  CreatePraktikum: {
    path: "/praktikum/create",
  },
  EditPraktikum: {
    path: "/praktikum/edit/:id",
  },
  ReportPraktikum: {
    path: "/praktikum/report",
  },
  OverviewPraktikum: {
    path: "/praktikum/overview",
  },
  // Cashflow
  ListCashflow: {
    path: "/cashflow/list",
  },
  DetailCashflow: {
    path: "/cashflow/detail/:id",
  },
  CreateCashflow: {
    path: "/cashflow/create",
  },
  EditCashflow: {
    path: "/cashflow/edit/:id",
  },
  ReportCashflow: {
    path: "/cashflow/report",
  },
  OverviewCashflow: {
    path: "/cashflow/overview",
  },
  // Mading
  ListMading: {
    path: "/mading/list",
  },
  DetailMading: {
    path: "/mading/detail/:slug",
  },
  CreateMading: {
    path: "/mading/create",
  },
  EditMading: {
    path: "/mading/edit/:slug",
  },
  ViewMading: {
    path: "/mading/view/:slug",
  },
  // Survey
  ListSurvey: { path: "/master/survey/list" },
  AddSurvey: { path: "/master/survey/add" },
  ViewSurvey: { path: "/master/survey/view/:id" },
  EditSurvey: { path: "/master/survey/edit/:id" },
  // Survey User
  InsertSurveyUser: { path: "/survey/answer/:id" },
  ListSurveyUser: { path: "/survey/list" },
  ViewSurveyUser: { path: "/survey/detail/:id/:idUser" },
  OverviewSurveyUser: { path: "/survey/overview" },
  // Import Bank Jatim
  ListImportMutasiBank: { path: "/mutasi-bank/list" },
  ViewImportMutasiBank: { path: "/mutasi-bank/detail/:id" },
  // Config Semester
  ViewConfigSemester: { path: "/config/semester" },
  // Staff Menu
  ListStaffMenu: { path: "/master/staff-menu/list" },
  AddStaffMenu: { path: "/master/staff-menu/add" },
  ViewStaffMenu: { path: "/master/staff-menu/view/:id" },
  EditStaffMenu: { path: "/master/staff-menu/edit/:id" },
  // User Discount
  ListUserDiscount: { path: "/master/user-discount/list" },
  AddUserDiscount: { path: "/master/user-discount/add" },
  ViewUserDiscount: { path: "/master/user-discount/view/:id" },
  EditUserDiscount: { path: "/master/user-discount/edit/:id" },
};
